export interface WorkflowParameterMap {
  parameterMapId?: string;
  workflowInstanceId: string;
  targetStepId: string;
  targetParameterIdx: number;
  sourceStepId?: string;
  sourceParameterIdx: number;
}
